import React, { useState, useEffect } from 'react';

function CategoryModal({ category, onSave, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    type: 'expense',
    is_recurring: false,
    use_prior_month: false,
  });

  useEffect(() => {
    if (category) {
      setFormData({
        name: category.name,
        type: category.type,
        is_recurring: !!category.is_recurring,
        use_prior_month: !!category.use_prior_month,
      });
    }
  }, [category]);

  function handleSubmit(e) {
    e.preventDefault();
    if (!formData.name.trim()) {
      alert('Please enter a category name');
      return;
    }
    onSave(formData);
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{category ? 'Edit Category' : 'Add Category'}</h2>
          <button onClick={onClose} className="modal-close">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="input-text"
              placeholder="Category name"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>Type</label>
            <select
              value={formData.type}
              onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              className="input-select"
            >
              <option value="expense">Expense</option>
              <option value="income">Income</option>
            </select>
          </div>

          <div className="form-group-checkbox">
            <label>
              <input
                type="checkbox"
                checked={formData.is_recurring}
                onChange={(e) => setFormData({ ...formData, is_recurring: e.target.checked })}
              />
              <span>Recurring category</span>
            </label>
          </div>

          <div className="form-group-checkbox">
            <label>
              <input
                type="checkbox"
                checked={formData.use_prior_month}
                onChange={(e) => setFormData({ ...formData, use_prior_month: e.target.checked })}
              />
              <span>Use same budget amount from prior month</span>
            </label>
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn btn-secondary">
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {category ? 'Update' : 'Create'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CategoryModal;
